import React, { useState } from 'react';
import { Phone, ArrowRight, AlertCircle, CheckCircle } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const LoginScreen = () => {
  const [step, setStep] = useState(1); // 1: Phone, 2: OTP
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handlePhoneSubmit = () => {
    if (!phone || phone.length < 10) {
      setError('Introduceți un număr de telefon valid');
      return;
    }
    setError('');
    setStep(2);
  };

  const handleVerification = () => {
    if (!code || code.length !== 4) {
      setError('Codul trebuie să aibă 4 cifre');
      return;
    }
    setError('');
    // Implement verification logic here
    // navigate('/dashboard');
  };

  const renderPhoneStep = () => (
    <div className="flex-1">
      {/* Phone Input */}
      <div className="space-y-4">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center">
            <Phone className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="Număr de telefon"
            className="w-full pl-12 pr-4 py-4 border border-gray-200 rounded-xl text-gray-800 text-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button
          onClick={handlePhoneSubmit}
          className="w-full bg-blue-600 text-white py-4 rounded-xl text-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
        >
          Trimite cod
          <ArrowRight className="ml-2 w-5 h-5" />
        </button>
      </div>

      {/* Social Login */}
      <div className="relative my-8">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200"></div>
        </div>
        <div className="relative flex justify-center">
          <span className="px-4 bg-white text-sm text-gray-500">
            sau continuă cu
          </span>
        </div>
      </div>

      <div className="space-y-3">
        <button className="w-full bg-black text-white py-4 rounded-xl text-lg font-medium hover:bg-gray-900 transition-colors flex items-center justify-center">
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/>
          </svg>
          Continuă cu Facebook
        </button>

        <button className="w-full bg-white border border-gray-200 text-gray-800 py-4 rounded-xl text-lg font-medium hover:bg-gray-50 transition-colors flex items-center justify-center">
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Continuă cu Google
        </button>

        <button className="w-full bg-white border border-gray-200 text-gray-800 py-4 rounded-xl text-lg font-medium hover:bg-gray-50 transition-colors flex items-center justify-center">
          <svg className="w-5 h-5 mr-3" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.477 2 2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.879V14.89h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.989C18.343 21.129 22 16.99 22 12c0-5.523-4.477-10-10-10z"/>
          </svg>
          Continuă cu Apple
        </button>
      </div>
    </div>
  );

  const renderVerificationStep = () => (
    <div className="flex-1">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-semibold text-gray-800">Verificare Cod</h2>
        <p className="text-gray-600 mt-2">
          Am trimis un cod la {phone}
        </p>
      </div>

      <div className="flex justify-center gap-3 mb-6">
        {[...Array(4)].map((_, i) => (
          <input
            key={i}
            type="text"
            maxLength="1"
            className="w-14 h-14 text-center border border-gray-200 rounded-xl text-2xl font-bold focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={code[i] || ''}
            onChange={(e) => {
              const newCode = code.split('');
              newCode[i] = e.target.value;
              setCode(newCode.join(''));
              
              // Auto-focus next input
              if (e.target.value && i < 3) {
                e.target.nextElementSibling?.focus();
              }
            }}
            onKeyDown={(e) => {
              // Handle backspace
              if (e.key === 'Backspace' && !code[i] && i > 0) {
                const prevInput = e.target.previousElementSibling;
                prevInput?.focus();
              }
            }}
          />
        ))}
      </div>

      <div className="space-y-4">
        <button
          onClick={handleVerification}
          className="w-full bg-blue-600 text-white py-4 rounded-xl text-lg font-medium hover:bg-blue-700 transition-colors flex items-center justify-center"
        >
          Verifică
          <CheckCircle className="ml-2 w-5 h-5" />
        </button>

        <button
          onClick={() => setStep(1)}
          className="w-full text-gray-600 py-2 hover:text-gray-800"
        >
          Schimbă numărul de telefon
        </button>

        <button className="w-full text-blue-600 py-2 hover:text-blue-700">
          Retrimite codul (30s)
        </button>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <div className="p-6 pb-10">
        <h1 className="text-3xl font-bold text-gray-900">Bine ai revenit!</h1>
        <p className="mt-2 text-gray-600">
          {step === 1 ? 'Autentifică-te pentru a continua' : 'Introdu codul primit prin SMS'}
        </p>
      </div>

      <div className="px-6 flex flex-col flex-1">
        {/* Error Message */}
        {error && (
          <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-xl flex items-center">
            <AlertCircle className="w-5 h-5 mr-2 flex-shrink-0" />
            <span>{error}</span>
          </div>
        )}

        {/* Steps */}
        {step === 1 ? renderPhoneStep() : renderVerificationStep()}

        {/* Register Link - Only show on first step */}
        {step === 1 && (
          <div className="mt-8 text-center">
            <p className="text-gray-600">
              Nu ai cont încă?{' '}
              <Link to="/register" className="text-blue-600 font-medium hover:text-blue-700">
                Înregistrează-te
              </Link>
            </p>
          </div>
        )}
      </div>

      {/* Terms and Privacy */}
      <div className="p-6">
        <p className="text-center text-sm text-gray-500">
          Prin continuare, accepți{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700">
            Termenii și Condițiile
          </a>
          {' '}și{' '}
          <a href="#" className="text-blue-600 hover:text-blue-700">
            Politica de Confidențialitate
          </a>
        </p>
      </div>
    </div>
  );
};

export default LoginScreen;